// extracted by mini-css-extract-plugin
module.exports = {"--font-secondary":"'Work Sans', sans-serif","--color-black":"#000000","--color-primary":"#1c53e7","link":"Link_link__1tsc3","icon":"Link_icon__3bATw"};